import React, { useEffect, useState } from "react";
import Header from "../../components/Header/Header";
import { Icons } from "../../assets/assets";
import Footer from "../../components/Footer/Footer";

import { Link } from "react-router-dom";

import { BiChevronRight } from "react-icons/bi";
import { ProductService } from "../../APIs";
import RefillModalSelection from "../../components/RefillModalSelection/RefillModalSelection";

import Retailers from "../../components/Modal/Retailers/Retailers";

const ExchangeRefill = () => {
  const [orderType, setOrderType] = useState<string>("exchange");

  const handleCardClick = (banner: string, id: number, orderType: string) => {
    setOrderType(orderType);
  };

  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const [isModalVisibleRetailer, setIsModalVisibleRetailer] = useState(false);

  const showModalRetailer = () => {
    setIsModalVisibleRetailer(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOptionSelect = (option: string) => {
    setIsModalVisible(false);

    if (option === "art") {
      handleCardClick(
        "https://sodastream.com/cdn/shop/products/bundle-blue-cyl-US.png?v=1708601134",
        36,
        orderType
      );
    } else if (option === "terra") {
      handleCardClick(
        "https://sodastream.com/cdn/shop/files/spare_2048pxX2048pxcopy2_9dc8c174-153a-48a6-8c25-6d3b90daf98b.png?v=1708694033",
        31,
        orderType
      );
    }
  };

  const cards = [
    {
      key: "terra",
      title: "Terra",
      description: "Uses CQC cylinder",
      imgSrc:
        "http://res.cloudinary.com/brabenjos/image/upload/v1704885569/sodastream/1704885569491.jpg",
    },
    {
      key: "art",
      title: "Art",
      description: "Uses Screw in cylinder",

      imgSrc:
        "http://res.cloudinary.com/brabenjos/image/upload/v1704519766/sodastream/1704519766224.jpg",
    },
  ];

  const fetchProductData = async () => {
    try {
      const { data, error } = await ProductService.getAllProducts();
      if (data) {
        // const filteredData = data.filter(
        //   (product) => product.product_type === "cylinders"
        // );
        // setProducts(filteredData);
      } else {
        console.error("Error fetching products:", error);
      }
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  // Call the method
  useEffect(() => {
    fetchProductData();
  }, []);
  const groupedCards = [];
  for (let i = 0; i < cards.length; i += 2) {
    groupedCards.push(cards.slice(i, i + 2));
  }

  return (
    <>
      <Header
        title="Refill & Exchange CO₂ Gas Cylinders"
        subTitle=""
        backgroundImg={
          "http://res.cloudinary.com/brabenjos/image/upload/v1723093154/sodastream/1723093153077.png"
        }
        textBackground="GAS Cylinders"
      />

      <div className="bg-white">
        <section className="flex flex-col md:flex-row p-6 bg-[#efebe4]">
          <div className="flex-1 p-4 m-2 rounded mt-[7%]">
            <h1
              className="box-border text-[rgb(0,93,110)] block  text-2xl font-semibold 
      leading-[38.4px] text-start">
              Refill & Exchange CO₂ Gas Cylinders
            </h1>
            <p
              className="box-border text-[rgb(0,34,56)] block  text-sm font-normal leading-normal mb-[15px]
     text-start">
              Exchange your empty cylinder for a full one and pay only for the
              refill. Each cylinder makes up to 15 gallons of fresh sparkling
              water.
            </p>

            <section className="flex gap-2 p-2  flex-col md:flex-row py-5">
              <div className=" ">
                <Retailers
                  showModal={showModalRetailer}
                  isModalVisible={isModalVisibleRetailer}
                  setIsModalVisible={setIsModalVisibleRetailer}
                  buttonClassName="w-[200px] h-[40px]  text-[16px] text-white font-bold rounded-full bg-[#75A7AD] flex items-center justify-center focus:outline-none"
                  buttonTitleClassName="text-[14px] leading-[24px] font 
                  font-bold text-white
                      sm:text-[16px] sm:leading-[19px]"
                />
              </div>

              <form className="w-full">
                <Link to={"/store-locator"}>
                  <div className="flex gap-1 items-center justify-start pt-[20px] text-[rgb(0,93,110)]">
                    <p className="text-[18px] font-bold flex items-center">
                      Find A Store
                      <span className="font-bold">
                        <BiChevronRight fontSize={30} />
                      </span>
                    </p>
                  </div>
                </Link>
              </form>
            </section>

            <section className="flex md:flex-row justify-start">
              <div className="flex-1 m-2"></div>
              <div className="m-2 w-full md:w-[200px]"></div>
            </section>
          </div>

          <div className="flex-1 p-4 m-2 rounded">
            <div className="relative basis-[40%]">
              <img
                src={
                  "http://res.cloudinary.com/brabenjos/image/upload/v1723814138/sodastream/1723814137820.webp"
                }
                alt="cylunder img"
                className=" bottom-0 left-0 z-50"
                style={{ width: "100%" }}
              />
            </div>
            <p
              className="box-border text-[#8b9195] text-xs font-normal h-[18px] leading-normal text-left
        mt-7">
              *Depending on the level of carbonation and type of SodaStream
              sparkling water maker.
            </p>
          </div>
        </section>

        <section className="flex flex-col md:flex-row p-6 ">
          <div className="flex-1 p-4 m-2 rounded">
            <div className="relative basis-[40%]">
              <img
                src={
                  "http://res.cloudinary.com/brabenjos/image/upload/v1723815654/sodastream/1723815654550.webp"
                }
                alt="cylunder img"
                className=" bottom-0 left-0 z-50"
                style={{ width: "100%" }}
              />
            </div>
          </div>
          <div className="flex-1 p-4 bg-white m-2 rounded mt-[7%]">
            <p
              className="box-border text-[rgb(0,93,110)] block 
     text-2xl font-semibold leading-[38.4px]   text-left">
              Each sparkling water maker is compatible with a specific cylinder:
              either the Classic screw-in system or the Quick Connect system.
            </p>

            <div className="flex-1 m-2">
              <div>
                <div className="flex gap-1 items-center justify-start pt-[20px] text-[#080A40]">
                  <p className="text-[18px] font-semibold" onClick={showModal}>
                    Which Cylinder do you need?{" "}
                  </p>
                </div>
              </div>
            </div>

            {/* here too */}
          </div>
        </section>

        <section>
          <div className="text-[#005D6E] flex flex-col gap-10 grid-cols-2 items-center justify-center py-5 md:px-20 md:py-20 md:pb-3">
            <h1
              className="box-border text-[rgb(0,34,56)] block 
     text-2xl font-semibold leading-[38.4px]   text-left">
              SodaStream benefits
            </h1>

            <div className="md:flex md:flex-nowrap flex-wrap gap-5 grid grid-cols-2 md:gap-0 justify-between items-center">
              <div className="flex flex-col gap-4 items-center justify-center">
                <img
                  className="md:w-[44%] w-[24%]"
                  src={Icons.IconSparklingSmall}
                  alt="sparkling water"
                />
                <span className="md:font-bold text-[14px]">
                  SUSTAINABLE SPARKLE
                </span>
              </div>

              <div className="flex flex-col gap-4 items-center justify-center">
                <img
                  className="md:w-[44%] w-[24%]"
                  src={Icons.IconQuickyEasy}
                  alt="sparkling water"
                />
                <span className="md:font-bold text-[14px]">QUICK & EASY</span>
              </div>

              <div className="flex flex-col gap-4 items-center justify-center">
                <img
                  className="md:w-[44%] w-[24%]"
                  src={Icons.IconQualityFirst}
                  alt="sparkling water"
                />
                <span className="md:font-bold text-[14px]">QUALITY FIRST</span>
              </div>

              <div className="flex flex-col gap-4 items-center justify-center">
                <img
                  className="md:w-[44%] w-[24%]"
                  src={Icons.IconFreshCertified}
                  alt="sparkling water"
                />
                <span className="md:font-bold text-[14px]">
                  FRESH & CERTIFIED
                </span>
              </div>
            </div>
          </div>
        </section>

        <section>
          <p
            className="box-border text-[#8b9195] text-xs font-normal leading-normal text-center w-full
       mb-7 mt-9">
            *Depending on the level of carbonation and type of SodaStream
            sparkling water maker.
          </p>
        </section>

        <RefillModalSelection
          isModalVisible={isModalVisible}
          handleCancel={handleCancel}
          handleOptionSelect={handleOptionSelect}
          groupedCards={groupedCards}
        />
        <Footer />
      </div>
    </>
  );
};

export default ExchangeRefill;
